import React from 'react';
import PropTypes from 'prop-types';
import ProjectTile from '../tiles/ProjectTile';
import FolderTile from '../tiles/FolderTile';
const filter = require('lodash/filter');
const indexOf = require('lodash/indexOf');

import FolderTileGoUp from '../tiles/FolderTileGoUp';
import TileListEmpty from '../tiles/TileListEmpty';

const propTypes = {
    projects: PropTypes.array,
    folders: PropTypes.array,
    folderMatchesFilter: PropTypes.func.isRequired,
    projectMatchesFilter: PropTypes.func.isRequired,
    filterActive: PropTypes.bool.isRequired,
    rootName: PropTypes.string,
    goToFolderView: PropTypes.func.isRequired,
    viewFolder: PropTypes.object,
    parentFolder: PropTypes.object,
    grandParentFolder: PropTypes.object,
};

const defaultProps = {
    rootName: '',
    projects: [],
    folders: [],
};

function ProjectTileList(props) {
    // TODO: activities matching filter be considered for this view?
    let rootProjects = [];
    let folderProjects = {};
    props.projects.forEach((proj) => {
        if (
            (!props.viewFolder && !proj.folder_id)
            || (!!props.viewFolder && props.viewFolder.id === proj.folder_id)
        ) {
            rootProjects.push(proj);
        }
        else {
            if (!folderProjects[proj.folder_id]) folderProjects[proj.folder_id] = [];
            folderProjects[proj.folder_id].push(proj);
        }
    });

    let filteredProjects = rootProjects;
    let filteredFolders = props.folders;
    if (props.filterActive) {
        filteredProjects = rootProjects.filter(p => props.projectMatchesFilter(p));
        filteredFolders = props.folders.filter(f => props.folderMatchesFilter(f));
    }

    return (
        <div className="tileList">
            {!!props.viewFolder && !props.filterActive &&
                <FolderTileGoUp
                    goUp={props.goToFolderView.bind(null, props.viewFolder.parent_id)}
                    parentName={props.parentFolder ? props.parentFolder.name : props.rootName }
                />
            }
            {filteredFolders.map((folder) => 
                <FolderTile
                    key={folder.id}
                    folder={folder}
                    onClick={props.goToFolderView.bind(null, folder.id)}
                />

            )}
            {filteredProjects.map((project) =>
                <ProjectTile
                    key={project.id}
                    project={project}
                />
            )}
            {props.filterActive && filteredProjects.length === 0 && filteredFolders.length === 0 &&
                <TileListEmpty promptText="No results for filter" />
            }
        </div>
    );
}

ProjectTileList.propTypes = propTypes;
ProjectTileList.defaultProps = defaultProps;

export default ProjectTileList;
